import { css } from 'styled-components';
import token from 'styled-token';
export var ComboboxLoadingStateMixin = token('ComboboxLoadingState.verticalSpacing', function (verticalSpacing) {
  return css(["display:flex;justify-content:center;align-items:center;padding-top:", "px;padding-bottom:", "px;"], verticalSpacing, verticalSpacing);
});